class User {
  constructor({ 
    uid, 
    email, 
    displayName = '', 
    photoURL = '', 
    phoneNumber = '',
    role = 'user',
    profileCompleted = false,
    createdAt = new Date(),
    updatedAt = new Date(),
    lastActive = new Date()
  }) {
    this.uid = uid;
    this.email = email;
    this.displayName = displayName;
    this.photoURL = photoURL;
    this.phoneNumber = phoneNumber;
    this.role = role; // 'user', 'admin', 'hr'
    this.profileCompleted = profileCompleted;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.lastActive = lastActive;
  }

  toFirestore() {
    return {
      uid: this.uid,
      email: this.email,
      displayName: this.displayName,
      photoURL: this.photoURL,
      phoneNumber: this.phoneNumber,
      role: this.role,
      profileCompleted: this.profileCompleted,
      createdAt: this.createdAt,
      updatedAt: new Date(),
      lastActive: new Date(),
    };
  }
  
  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new User({
      uid: data.uid || snapshot.id,
      email: data.email,
      displayName: data.displayName || '',
      photoURL: data.photoURL || '',
      phoneNumber: data.phoneNumber || '',
      role: data.role || 'user',
      profileCompleted: data.profileCompleted || false,
      createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
      updatedAt: data.updatedAt ? data.updatedAt.toDate() : new Date(),
      lastActive: data.lastActive ? data.lastActive.toDate() : new Date(),
    });
  }

  // Helper methods
  isAdmin() {
    return this.role === 'admin';
  }

  isHR() {
    return this.role === 'hr';
  }

  canManageApplications() {
    return this.role === 'admin' || this.role === 'hr';
  }
}

export default User;